import { IActivityBase } from '../../models/activities';
import { IVentureBase } from '../../models/ventures';
import wbsBookingsApi from '../apis/wbsBookingsApi';

interface IUpdateActivityProps {
  activityId: string;
  bookingPrice?: number;
  description?: string;
  isActive?: boolean;
  isVerified?: boolean;
  name: string;
  spotId: string;
}

export interface IUpdatedActivity extends IActivityBase {
  ventures: IVentureBase[];
}

export const updateActivitiesService = async ({
  activityId,
  bookingPrice,
  description,
  isActive,
  isVerified,
  name,
  spotId,
}: IUpdateActivityProps): Promise<IUpdatedActivity> => {
  const { data } = await wbsBookingsApi.put<IUpdatedActivity>(
    `/activities/${activityId}`,
    {
      bookingPrice,
      description,
      isActive,
      name,
      spotId,
    },
    { params: { isVerified } },
  );

  return data;
};
